export type LocationType = {
  longitude: number
  latitude: number
}

export type LocationErrorType =
  | 'NOT_SUPPORTED'
  | 'PERMISSION_DENIED'
  | 'POSITION_UNAVAILABLE'
  | 'TIMEOUT'
  | 'UNKNOWN'
  | 'NO_PERMISSION' // trường hợp askPermission = false và chưa granted

export type LocationResult = {
  location: LocationType | null
  error: LocationErrorType | null
  message?: string
}

export const getLocation = async (
  askPermission = true,
): Promise<LocationResult> => {
  if (!('geolocation' in navigator)) {
    return {
      location: null,
      error: 'NOT_SUPPORTED',
      message: 'Geolocation not supported',
    }
  }

  // Nếu không muốn hỏi quyền thì kiểm tra permission trước
  if (!askPermission && 'permissions' in navigator) {
    try {
      const permission = await navigator.permissions.query({
        name: 'geolocation' as PermissionName,
      })

      if (permission.state !== 'granted') {
        return {
          location: null,
          error: 'NO_PERMISSION',
          message: 'User has not granted geolocation permission',
        }
      }
    } catch (err) {
      console.warn('Permission query failed:', err)
      return {
        location: null,
        error: 'UNKNOWN',
        message: 'Permission check failed',
      }
    }
  }

  // Gọi geolocation
  return new Promise<LocationResult>((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          location: {
            longitude: position.coords.longitude,
            latitude: position.coords.latitude,
          },
          error: null,
        })
      },
      (err) => {
        let errorType: LocationErrorType = 'UNKNOWN'

        switch (err.code) {
          case err.PERMISSION_DENIED:
            errorType = 'PERMISSION_DENIED'
            break
          case err.POSITION_UNAVAILABLE:
            errorType = 'POSITION_UNAVAILABLE'
            break
          case err.TIMEOUT:
            errorType = 'TIMEOUT'
            break
        }

        resolve({
          location: null,
          error: errorType,
          message: err.message,
        })
      },
      {
        timeout: 30000,
        maximumAge: 0,
      },
    )
  })
}
